module.exports = __webpack_public_path__ + "static/media/finanzas-tradicionales.9aea7868.svg";